/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/video'
export default icon
